<template>
  <row class="overflow-x-hidden py-8" justify="center">
    <row justify="center">
      <column>
        <a class="w-60 mb-12" href="https://www.fitt.ai">
          <img
              class="home-page-main-logo cursor-pointer"
              src="@/assets/logos/fitt_light.png"
              alt="fitt_light"
          ></a>
      </column>
    </row>

    <div style="max-width: 600px; border-radius: 1.5em"
         class="h-2/4 flex flex-row items-center bg-white p-8 rounded-xl shadow-xl text-center mb-4 mx-4">
      <row class="w-full">
        <column class="w-full">
          <h3 class="w-full text-center text-lg font-semibold mb-6 mt-6">Social Links</h3>

          <!--      SOCIAL LINKS    -->
          <row>
            <template v-for="link in socialLinks">
              <div
                  :key="link.value"
                  style="box-shadow: 0 4px 8px 2px rgba(136, 136, 136, 0.5);"
                  class="relative w-full h-20 mb-3 flex text-center justify-center items-center space-x-2 bg-white-100 hover:bg-gray-200 text-gray-700 font-sm py-2 px-4 rounded-lg transition duration-200">
                <a
                    style="width: 100%; height: 100%;"
                    class="flex items-center justify-center"
                    :href="link.address"
                    target="_blank"
                >
                  <Icon
                      ref="icon"
                      v-if="link.icon"
                      class="absolute ml-6 left-0"
                      :icon="link.icon">
                  </Icon>
                  <Icon
                      v-else
                      class="absolute ml-6 left-0"
                      icon="link">
                    >
                  </Icon>
                  <span v-if="link.name">{{ link.name }}</span>
                </a>
              </div>
            </template>
          </row>
<!--          <row>-->
<!--            <div-->
<!--                style="box-shadow: 0 4px 8px 2px rgba(136, 136, 136, 0.5);"-->
<!--                class="relative w-full h-20 mb-3 flex text-center justify-center items-center space-x-2 bg-white-100 hover:bg-gray-200 text-gray-700 font-sm py-2 px-4 rounded-lg transition duration-200"-->
<!--            >-->
<!--              <a-->
<!--                  style="width: 100%;"-->
<!--                  href="https://www.fitt.ai"-->
<!--                  target="_blank"-->
<!--              >-->
<!--                <Icon-->
<!--                    class="absolute ml-6 left-0"-->
<!--                    icon="earth">-->
<!--                  >-->
<!--                </Icon>-->
<!--                <span>fitt Website</span>-->
<!--              </a>-->
<!--            </div>-->
<!--          </row>-->

          <!--      LOGOS       -->
          <row>
            <row class="w-full flex justify-center items-center">
              <template v-for="logo in logos">
                <column :key="logo.name" class="flex items-center" cols="auto">
                  <img class="my-8"
                       :src="logo.src"
                       :alt="logo.name"
                       style="max-width: 100px; max-height:100px;"
                       height="100"
                       width="100"
                  >
                </column>
              </template>
            </row>
          </row>
        </column>
      </row>
    </div>
  </row>
</template>

<script>

import Icon from "@/components/display/Icon.vue";

export default {
  name: "FittLinkTree.vue",
  components: {
    Icon,
  },
  data: function () {
    return {
      socialLinks: [
        {
          name: 'fitt Website',
          icon: 'earth',
          address: 'https://www.fitt.ai',
        },
        {
          name: 'LinkedIn',
          icon: 'linkedin',
          address: 'https://www.linkedin.com/company/fitt-talent/',
        },
        {
          name: 'YouTube',
          icon: 'youtube',
          address: 'https://www.youtube.com/@fittTalent',
        },
        // {
        //   name: 'Vimeo',
        //   icon: 'vimeo',
        //   address: 'https://vimeo.com/fitttalent',
        // },
      ],
      logos: [
        {
          name: 'isomark',
          src: require('@/assets/isomark.png'),
        },
        {
          name: 'best-analytics',
          src: require('@/assets/logos/best-analytics.png'),
        },
        {
          name: 'future-hr',
          src: require('@/assets/logos/future-hr.png'),
        },
        {
          name: 'sustainability',
          src: require('@/assets/logos/winer-sustainability-icon.png'),
        },
        {
          name: 'tech-innovations',
          src: require('@/assets/logos/winner-tech-innovation-awards-icon.png'),
        },
      ]
    }
  },
  methods: {
    navigateToLink(address) {
      window.location.href = address;
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
</style>